import { useState, useEffect, useCallback } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Button from "../../../../components/Button";
import { useIsMobile } from "../../../../helpers/ui";
import { colors } from "../../../../styles";
import { Card } from "../Account/components";
import { useStoreState } from "../../../../store";
import T from "../../../../components/Typography";
import { TextInput } from "../../../../components/General";
import TransfersService from "../../../../api/services/TransfersService";
import { employeeTransfersInitiated } from "../../../../routes/paths";

const Verification = () => {
  const transferState = useStoreState((state) => state.transfer);
  const [code, setCode] = useState<string>("");
  const [initialCodeSent, setInitialCodeSent] = useState<boolean>(false);
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  const sendVerificationCode = useCallback(async () => {
    if (transferState.createdTransferId) {
      const response = await TransfersService.sendVerificationCode(
        transferState.createdTransferId
      );
      if (response?.data.success) {
        setInitialCodeSent(true);
        return true;
      } else {
        toast.error(
          "Unable to send verification code. Please contact our support team in Chat and we will help!"
        );
        return false;
      }
    }
  }, [transferState.createdTransferId]);

  useEffect(() => {
    if (!initialCodeSent) {
      sendVerificationCode();
    }
  }, [sendVerificationCode, initialCodeSent]);

  const handleConfirm = async () => {
    if (transferState.createdTransferId) {
      const response = await TransfersService.confirmVerificationCode(
        transferState.createdTransferId,
        code
      );
      if (response?.data.success) {
        navigate(employeeTransfersInitiated);
        return;
      }
    }
  };

  const resendCode = async () => {
    const success = await sendVerificationCode();
    if (success) {
      toast.success("Your new verification code was sent");
    }
  };

  return (
    <Card
      hideStyleOnMobile
      sx={{
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        ...(!isMobile && {
          paddingLeft: "150px",
          paddingRight: "150px",
          height: "430px",
          minHeight: "430px",
        }),
        ...(isMobile && { display: "flex", flexDirection: "column" }),
      }}
    >
      <T variant="headingSm">
        We sent you a 2-factor code to confirm your identity
      </T>
      <TextInput
        placeholder="SMS 2 factor code"
        value={code}
        onChange={(e) => setCode(e.target.value)}
        size="small"
      />
      <T variant="mdReg" sx={{ marginTop: "16px" }}>
        Didn't receive a text?{" "}
        <span
          style={{ color: colors.info_blue, cursor: "pointer" }}
          onClick={resendCode}
        >
          Resend code
        </span>
      </T>
      <Button
        noMargin
        sx={{ marginTop: "32px" }}
        onClick={handleConfirm}
        disabled={!code}
      >
        Confirm & Transfer
      </Button>
    </Card>
  );
};

export default Verification;
